/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react';
import Grid from '@elliemae/ds-grid';
import {
  AlertsSmallFill,
  ExceptionsSmallFill,
  Notifications as InternalNotifications,
  MessagesSmallFill,
} from '@elliemae/ds-icons';
import { styled } from '@elliemae/ds-system';
import { DSLeftNavigationName, LEFT_NAVIGATION_DATA_TESTID, LEFT_NAVIGATION_SLOTS } from '../../constants/index.js';
import { LeftNavContext } from '../../LeftNavigationContext.js';

const StyledIconContainer = styled('div', {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.NOTIFICATIONS_CONTAINER,
})`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
type NotificationsProps = {
  exceptions?: boolean;
  alerts?: boolean;
  messages?: boolean;
};
const StyledInternalNotifications = styled(InternalNotifications, {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.NOTIFICATIONS_ICON,
})``;
const StyledExceptionsSmallFillWrapper = styled(Grid, {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.EXCEPTIONS_ICON_WRAPPER,
})``;
const StyledAlertsSmallFillWrapper = styled(Grid, {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.ALERTS_ICON_WRAPPER,
})``;
const StyledMessagesSmallFillWrapper = styled(Grid, {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.MESSAGES_ICON_WRAPPER,
})``;

export const Notifications = ({
  exceptions = false,
  alerts = false,
  messages = false,
}: NotificationsProps): JSX.Element => {
  const ctx = React.useContext(LeftNavContext);
  const { leftNavProps } = ctx;
  const getOwnerProps = React.useCallback(() => leftNavProps, [leftNavProps]);
  const getOwnerPropsArguments = React.useCallback(() => ({}), []);
  return (
    <StyledIconContainer
      data-testid={LEFT_NAVIGATION_DATA_TESTID.NOTIFICATIONS_CONTAINER} // https://jira.elliemae.io/browse/PUI-15589
      getOwnerProps={getOwnerProps}
      getOwnerPropsArguments={getOwnerPropsArguments}
    >
      <StyledInternalNotifications
        size="m"
        color={['brand-primary', '800']}
        data-testid={LEFT_NAVIGATION_DATA_TESTID.NOTIFICATIONS_ICON} // https://jira.elliemae.io/browse/PUI-15589
        getOwnerProps={getOwnerProps}
        getOwnerPropsArguments={getOwnerPropsArguments}
      />
      {(exceptions || alerts || messages) && (
        <Grid cols={['1fr', '1fr', '1fr']} gutter="xxxs" mt="2px">
          <StyledExceptionsSmallFillWrapper
            width="6px"
            height="6px"
            data-testid={LEFT_NAVIGATION_DATA_TESTID.EXCEPTIONS_ICON_WRAPPER} // https://jira.elliemae.io/browse/PUI-15589
            getOwnerProps={getOwnerProps}
            getOwnerPropsArguments={getOwnerPropsArguments}
          >
            {exceptions && <ExceptionsSmallFill width="6px" height="6px" color={['warning', '900']} />}
          </StyledExceptionsSmallFillWrapper>
          <StyledAlertsSmallFillWrapper
            width="6px"
            height="6px"
            data-testid={LEFT_NAVIGATION_DATA_TESTID.ALERTS_ICON_WRAPPER} // https://jira.elliemae.io/browse/PUI-15589
            getOwnerProps={getOwnerProps}
            getOwnerPropsArguments={getOwnerPropsArguments}
          >
            {alerts && <AlertsSmallFill width="6px" height="6px" color={['danger', '900']} />}
          </StyledAlertsSmallFillWrapper>
          <StyledMessagesSmallFillWrapper
            width="6px"
            height="6px"
            data-testid={LEFT_NAVIGATION_DATA_TESTID.MESSAGES_ICON_WRAPPER} // https://jira.elliemae.io/browse/PUI-15589
            getOwnerProps={getOwnerProps}
            getOwnerPropsArguments={getOwnerPropsArguments}
          >
            {messages && <MessagesSmallFill width="6px" height="6px" color={['success', '900']} />}
          </StyledMessagesSmallFillWrapper>
        </Grid>
      )}
    </StyledIconContainer>
  );
};

export default Notifications;
